(() => {
  if (window.Shopify && window.Shopify.designMode) return;

  const blockEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  document.addEventListener('contextmenu', blockEvent, true);
  document.addEventListener('dragstart', (event) => {
    if (event.target && event.target.closest('img, video, picture, svg')) {
      blockEvent(event);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('img, video, svg').forEach((element) => {
      element.setAttribute('draggable', 'false');
    });
  });
})();
